<template>
    <v-dialog
      v-model="isSuccessed"
      persistent
      max-width="60%"
    >
      <v-card>
         <v-card-text class="text-center">
            <div><v-icon class="my-5" color="teal darken-1" x-large>mdi-checkbox-marked-circle</v-icon></div>
            <p v-html="successText"></p>

            <div class="my-3 text-left">
              <v-card v-show="hasOpinion" outlined max-width="90%" class="mx-auto" color="amber lighten-5">
                <v-card-title>
                  <v-icon class="mr-1" color="red" large>mdi-information</v-icon>
                  <span class="title font-weight-light">引き続き見積内容のご相談に回答してください</span>          
                </v-card-title>
                <v-card-text class="body-2 black--text">
                  ご相談に回答していないサンプルが残っています。<br>
                  <br>
                  引き続き見積内容のご相談を確認して下さい。<br>
                </v-card-text>
              </v-card>

              <v-card v-show="!hasOpinion" outlined max-width="90%" class="mx-auto" color="green lighten-5">
                <v-card-title>
                  <v-icon class="mr-1" color="primary" large>mdi-information</v-icon>
                  <span class="title font-weight-light">お見積り依頼を回答しました。</span>          
                </v-card-title>
                <v-card-text class="body-2 black--text">
                  すべてのご相談に回答しました。<br>
                  <br>
                  お客様にお見積書の発行完了を通知します。<br>
                </v-card-text>
              </v-card>
            </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="teal darken-1"
            rounded
            outlined
            @click="showDialog()"
            class="mb-5 mr-3"
          >
            スタッフＴＯＰに戻る
          </v-btn>

        </v-card-actions>
      </v-card>
    </v-dialog>
</template>
<script>
export default {
    props:["successUrl","successText"],
    data: () => ({
        isSuccessed: false,
        id: "",
        hasOpinion: false,
//        precautions_url: process.env.VUE_APP_PRECAUTIONS_URL,
        precautions_url: "https://www.japan-analysts.com/oilmatrix/J20-28-21-009-002_Precautions.pdf",
    }),
    methods: {
      showDialog() {
        this.isSuccessed = false
//          this.$router.back()
        this.$router.push(this.successUrl)
      },
      openPrecautions() {
        console.log("process.env", process.env)
        window.open(this.precautions_url, '_blank')
      },
      open(ifjson) {
        console.log('result from modal:', ifjson)
        this.id = ifjson.id
        this.hasOpinion = ifjson.hasOpinion
        
        this.isSuccessed = true
      }
    }
}
</script>

